import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Props {
  open: boolean;
  onClose: () => void;
}

const TARGETS = [
  { label: "微信", icon: "ri-wechat-line" },
  { label: "微博", icon: "ri-weibo-line" },
  { label: "QQ", icon: "ri-qq-line" },
  { label: "复制链接", icon: "ri-link" },
];

export default function ShareDialog({ open, onClose }: Props) {
  const [copied, setCopied] = useState("");

  useEffect(() => {
    if (!open) setCopied("");
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭分享弹窗"
        onClick={onClose}
        className="absolute inset-0 bg-background-950/80 backdrop-blur-sm cursor-default"
      />
      <div className="relative w-full max-w-[420px] rounded-lg border hairline bg-background-900 p-5 animate-pop-in">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="font-heading text-base font-semibold text-foreground-50">分享给同好</h2>
            <p className="mt-1 text-xs text-foreground-400">演示状态：分享功能待接入第三方平台</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 rounded-md flex items-center justify-center text-foreground-400 hover:text-foreground-100 hover:bg-background-800 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-2">
          {TARGETS.map((target) => (
            <button
              key={target.label}
              type="button"
              onClick={() => setCopied(`${target.label}分享为演示功能，待接入`)}
              className="flex flex-col items-center gap-2 py-3 rounded-md border hairline bg-background-800/60 hover:border-accent-500/50 transition-colors cursor-pointer"
            >
              <span className="w-9 h-9 rounded-full flex items-center justify-center bg-primary-800/60 text-accent-300">
                <i className={`${target.icon} text-lg`} />
              </span>
              <span className="text-[11px] text-foreground-300 whitespace-nowrap">{target.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-4 rounded-md border hairline bg-background-950/70 px-3 py-2.5">
          <p className="text-[11px] leading-5 text-foreground-400">
            {copied || "功能演示，待接入。正式版本会生成带作品信息的分享卡片。"}
          </p>
        </div>

        <div className="mt-4 flex items-center gap-2">
          <Link
            to="/about#faq"
            onClick={onClose}
            className="flex-1 h-9 rounded-md bg-background-800 text-foreground-200 text-xs flex items-center justify-center hover:bg-background-700 transition-colors whitespace-nowrap"
          >
            了解分享说明
          </Link>
          <button
            type="button"
            onClick={onClose}
            className="flex-1 h-9 rounded-md bg-accent-500 text-background-950 text-xs font-medium flex items-center justify-center hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
}